import React, { useState } from 'react';

interface ReadMoreListProps {
    text: string;
    limit?: number; // number of visible items when collapsed
}

const ReadMoreList: React.FC<ReadMoreListProps> = ({ text, limit = 2 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return null;

    // Clean and split the string
    const items = text
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

    const isLong = items.length > limit;
    const visibleItems = expanded ? items : items.slice(0, limit);

    const toggle = () => setExpanded((prev) => !prev);

    return (
        <div>
            <ol style={{ paddingLeft: 16 }}>
                {visibleItems.map((item, idx) => (
                    <li key={idx}>{item}</li>
                ))}
            </ol>
            {isLong && (
                <div style={{ color: 'blue', cursor: 'pointer', marginTop: 4 }} onClick={toggle}>
                    {expanded ? 'Read less' : 'Read more'}
                </div>
            )}
        </div>
    );
};

export default ReadMoreList;
